import React, { useEffect, useState } from "react";
import { SimpleTable } from "../../ui/SimpleTable/SimpleTable";
import { useFetchPagedGeofence } from "../../../../../hooks/guide/useFetchPagedGeofence";
import { Geofence } from "../../../../../types/api/guide/geofence.types";
import EditGeofenceModal from "../../../../MapMonitoring/components/EditGeofenceModal/EditGeofenceModal";
import { geofenceService } from "../../../../../services/guide/geofence-service";
import useAppSnackbar from "../../../../../hooks/useAppSnackbar";
import { ConfirmDialog } from "../../ConfirmDialog/ConfirmDialog";
import { useDebouncedValue } from "../../../../../hooks/useDebouncedValue";
import { PagedResultDto } from "../../../../../types/api/PagedResultDto";

interface GeozoneTableProps {
    title: string;
}

export const GeozonesTable = ({ title }: GeozoneTableProps) => {
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [search, setSearch] = useState("");
    const debouncedSearch = useDebouncedValue(search, 350);

    useEffect(() => {
        setPage(1);
    }, [debouncedSearch]);

    const { data: paged, isLoading, error, refetch } = useFetchPagedGeofence(
        page,
        pageSize,
        debouncedSearch.trim() || undefined
    );

    const { showSuccess, showError, SnackbarComponent } = useAppSnackbar();
    const [isOpenEdit, setOpenEdit] = useState<{ isOpen: boolean; id: string }>({
        isOpen: false,
        id: "",
    });

    const [toDelete, setToDelete] = useState<Geofence | null>(null);

    const pageData = paged as PagedResultDto<Geofence> | null | undefined;
    const items = pageData?.items ?? [];
    const totalCount = pageData?.totalCount ?? 0;

    const handleDelete = async (id: string) => {
        try {
            await geofenceService.delete(id);
            showSuccess("Успешное удаление");
            refetch();
        } catch (e: any) {
            showError(e.response?.data);
            console.log("Ошибка при удалении допустимого типа загрузки");
        }
    };

    return (
        <>
            <SimpleTable<Geofence>
                title={title}
                columns={[
                    { key: "name", title: "Название" },
                    { key: "coordinates", title: "Координаты" },
                    { key: "description", title: "Описание" },
                ]}
                loading={isLoading}
                error={error}
                data={items}
                enableSearchByName
                searchPlaceholder="Поиск по названию"
                serverPagination={{
                    totalCount,
                    page,
                    pageSize,
                    onPageChange: setPage,
                    onPageSizeChange: (s) => {
                        setPageSize(s);
                        setPage(1);
                    },
                    searchValue: search,
                    onSearchChange: setSearch,
                }}
                getRowKey={(r) => r.id}
                getRowActions={(row) => ({
                    onEdit: () => setOpenEdit({ isOpen: true, id: row.id }),
                    onDelete: () => setToDelete(row),
                })}
                emptyText="Справочник пуст"
            />

            <ConfirmDialog
                open={!!toDelete}
                title="Удалить геозону?"
                description={toDelete ? `Будет удалена: ${toDelete.name}` : undefined}
                onCancel={() => setToDelete(null)}
                onConfirm={() => {
                    if (!toDelete) return;
                    handleDelete(toDelete.id);
                    setToDelete(null);
                }}
            />

            {isOpenEdit.isOpen && (
                <EditGeofenceModal
                    id={isOpenEdit.id}
                    onClose={() => setOpenEdit({ isOpen: false, id: "" })}
                    refetchData={refetch}
                />
            )}
            <SnackbarComponent />
        </>
    );
};
